import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import CartSheet from "@/components/site/CartSheet";
import OrderDialog from "@/components/site/OrderDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  const [business, setBusiness] = useState({
    name: "Halli Chutney",
    email: "",
    phone: "",
    whatsapp: "",
    location: "",
  });
  const [orderOpen, setOrderOpen] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/business-info`)
      .then((r) => setBusiness(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-stone-50 text-stone-900 overflow-x-hidden">
      <Header onOrder={() => setOrderOpen(true)} />
      <main>
        <Hero onOrder={() => setOrderOpen(true)} />
        <Marquee />
        <About />
        <Products />
        <WhyChooseUs />
        <Reviews />
        <Contact business={business} />
      </main>
      <Footer business={business} />
      <CartSheet onCheckout={() => setOrderOpen(true)} />
      <OrderDialog
        open={orderOpen}
        onOpenChange={setOrderOpen}
        business={business}
      />
    </div>
  );
}
